import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import ErrorPage from '../error/errorPage';
import { getSyscoShopAuthToken } from '../../redux/slice/authShopSlice';
import ShopLoginForm from '../forms/shopLoginForm';
import Loading from '../loading/loading';
export default function AuthShop() {
    const { orderReferenceId } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSyscoShopAuthToken(orderReferenceId));
    }, [dispatch, orderReferenceId]);


    const { isFetchTokenLoading,
        fetchTokenError,
        isFetchTokenSuccess,
    } = useSelector(state => state.authShop);

    //TODO: move error to a different component
    let content;
    if (isFetchTokenLoading) {
        content = <Loading />;
    } else if (isFetchTokenSuccess) {
        content = <ShopLoginForm />;
    } else {
        content = <ErrorPage errorMessage={JSON.stringify(fetchTokenError)} />;
    }

    return (
        <>
            {content}
        </>
    )
}
